import { Airror, CONFLICT } from '@air/errors';

const isConflictError = (error: unknown): boolean => error instanceof Airror && error.type === CONFLICT.type;

/** A workspace-scoped name (a saved size or a set) collided with an existing one. */
export const getMutationErrorMessage = (error: unknown, fallback: string): string =>
  isConflictError(error) ? 'That name is already taken' : fallback;
